module.exports = __webpack_public_path__ + "static/media/edit_constraints_teacher_availability.1220b486.mov";